import goeltmtImg from "../assets/portfolio/goeltmt.png";
import fleetLink from "../assets/portfolio/fleetlink.png";
import bizex from "../assets/portfolio/bizex.png";
import maihealth from "../assets/portfolio/maaihealth.png";
import anzen from "../assets/portfolio/anzen.png";
import Footer from "./Footer";
import Navbar from "./Navbar";

import { ReactComponent as GoogleLogo } from "../assets/googlestore.svg";
import { ReactComponent as AppleLogo } from "../assets/applestore.svg";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ContactUsBanner from "../component/ContactUsBanner";

export default function Portfolio() {
  const appLists = [
    {
      name: "Goeltmt",
      image: goeltmtImg,
      applelink: "https://apps.apple.com/us/app/goeltmt/id1047335433",
      googlelink:
        "https://play.google.com/store/apps/details?id=com.tmt.goeltmt1&hl=en_IN",
    },
    {
      name: "FleetLink",
      image: fleetLink,
      applelink: "https://apps.apple.com/us/app/fleetlink/id6472271296",
      googlelink:
        "https://play.google.com/store/apps/details?id=in.fleetlink&hl=en_IN",
    },
    { name: "MaiHealth", image: maihealth, applelink: "", googlelink: "" },
    {
      name: "Bizex",
      image: bizex,
      applelink: "https://apps.apple.com/ca/app/bizsold/id1626734998",
      googlelink: "https://play.google.com/store/apps/details?id=com.bizexapp",
    },
    { name: "Anzen", image: anzen, applelink: "", googlelink: "" },
  ];

  const PortfolioItem = ({ image, applelink, googlelink }) => {
    return (
      <div
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          margin: "60px",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        {applelink.length > 0 && (
          <div
            style={{
              bottom: "40px",
              position: "absolute",
              left: "5%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <span
              style={{ fontSize: "14px", fontWeight: "bold", color: "#fff" }}
            >
              Download Now:
            </span>
            <div style={{ display: "flex", gap: "10px" }}>
              <a href={applelink} target="_blank" rel="noopener noreferrer">
                <AppleLogo />
              </a>
              <a href={googlelink} target="_blank" rel="noopener noreferrer">
                <GoogleLogo />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>Appscasa</title>
        <meta
          name="description"
          content="Appscasa is highly skilled Mobile App Development Company In India. We design and develop mobile apps that delight your users and grow your business."
        />
      </Helmet>

      <header
        className="pages valign bg-img parallaxie"
        data-background="assets/img/bg.jpg"
        data-overlay-dark={7}
      >
        <div className="container">
          <div className="row">
            <div className="full-width mt-80">
              <h5>Portfolio</h5>
              <h6>
                <Link to="/">Home</Link>/
                <Link to="/portfolio" className="active">
                  Portfolio
                </Link>
              </h6>
            </div>
          </div>
        </div>
      </header>

      {appLists.map((item, index) => {
        return PortfolioItem(item);
      })}
     <ContactUsBanner/>
      <Footer />
    </>
  );
}
